// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2559a60b","909":"92d59874","927":"70b1368b","999":"906d8361"}[chunkId] + ".chunk.js";
};